import { logoutThunk } from "@/store/slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

interface MenuCard {
  icon: string;
  title: string;
  description: string;
  path: string;
  iconBg: string;
  iconColor: string;
}

const menuCards: MenuCard[] = [
  {
    icon: "ri-calendar-check-line",
    title: "직접 예약",
    description: '',
    // description: "특정 업체들의 예약 가능 시간을 직접 확인 후 드레스 투어를 구성하세요",
    path: "/shop-calendar?weekStart=2026-10-01",
    iconBg: "#FFF7ED",
    iconColor: "#EA580C",
  },
  {
    icon: "ri-route-line",
    title: "자동 예약",
    // description: "여러 업체를 선택해 날짜별로 가능한 조합을 2시간 간격으로 자동으로 추천해드립니다",
    description: '',
    path: "/vendors",
    iconBg: "#EFF6FF",
    iconColor: "#2563EB",
  },
  // {
  //   icon: "ri-map-pin-2-line",
  //   title: "드레스샵 지도 보기",
  //   description: "드레스샵 위치를 지도에서 한눈에 확인하세요",
  //   path: "/map",
  //   iconBg: "#F0FDF4",
  //   iconColor: "#16A34A",
  // },
  
  {
    icon: "ri-bookmark-3-line",
    title: "내 예약 보기",
    // description: "내가 진행한 드레스 투어 예약 내역을 확인하세요",
    description: '',
    path: "/reservations",
    iconBg: "#FDF4FF",
    iconColor: "#9333EA",
  },
];

export default function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const now = new Date();
  const hours = now.getHours();
  let greeting = "안녕하세요";
  if (hours >= 5 && hours < 12) greeting = "좋은 아침이에요";
  else if (hours >= 12 && hours < 18) greeting = "안녕하세요";
  else if (hours >= 18 && hours < 22) greeting = "좋은 저녁이에요";
  else greeting = "안녕하세요";
  const authUser = useSelector((state: any) => state.auth.user);

  const plannerDisplayName = authUser?.userName
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col mx-auto max-w-4xl border-x border-gray-200" style={{ backgroundColor: "#F5F6F8" }}>
      {/* Top Bar */}
      <div
        className="bg-white border-b px-5 py-4 flex items-center justify-between"
        style={{ borderColor: "#F3F4F6" }}
      >
        <div className="flex items-center gap-2.5">
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: "#2563EB" }}
          >
            <i className="ri-calendar-check-line text-white text-sm"></i>
          </div>
          <span className="text-sm font-semibold" style={{ color: "#111827" }}>
            드레스 투어 스케줄링
          </span>
        </div>
        <button
          onClick={() => dispatch(logoutThunk())}
          className="sm:w-full sm:w-auto px-5 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] transition-colors whitespace-nowrap cursor-pointer"
          style={{width: 90}}
        >
          로그아웃
        </button>
      </div>

      {/* Header Section */}
      <div className="px-5 pt-8 pb-6">
        <p className="text-sm font-medium mb-1" style={{ color: "#6B7280" }}>
          {greeting}, {plannerDisplayName} 플래너님
        </p>
        <h1 className="text-2xl font-bold" style={{ color: "#111827" }}>
          플래너 홈
        </h1>
        <p className="text-sm mt-1.5" style={{ color: "#9CA3AF" }}>
          원하는 기능을 선택해 예약 업무를 진행하세요
        </p>
      </div>

      {/* Menu Cards Grid */}
      <div className="px-5 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {menuCards.map((card) => (
            <button
              key={card.path}
              onClick={() => navigate(card.path)}
              className="bg-white rounded-2xl p-5 text-left flex items-start gap-4 hover:scale-[1.01] active:scale-[0.99] transition-transform cursor-pointer w-full items-center"
              style={{
                border: "1px solid #F3F4F6",
              }}
            >
              {/* Icon */}
              <div
                className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: card.iconBg }}
              >
                <i
                  className={`${card.icon} text-xl`}
                  style={{ color: card.iconColor }}
                ></i>
              </div>

              {/* Text */}
              <div className="flex-1 min-w-0 flex">
                <p
                  className="text-md font-semibold mb-1"
                  style={{ color: "#111827" }}
                >
                  {card.title}
                </p>
                <p
                  className="text-xs leading-relaxed"
                  style={{ color: "#9CA3AF", display: 'none' }}
                >
                  {card.description}
                </p>
              </div>

              {/* Arrow */}
              <div
                className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5"
                style={{ color: "#D1D5DB" }}
              >
                <i className="ri-arrow-right-s-line text-lg"></i>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Quick Status Bar */}
      <div className="px-5 pb-8" style={{display: 'none'}}>
        <div
          className="bg-white rounded-2xl px-5 py-4 flex items-center gap-3"
          style={{ border: "1px solid #F3F4F6" }}
        >
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: "#EFF6FF" }}
          >
            <i className="ri-information-line text-sm" style={{ color: "#2563EB" }}></i>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium" style={{ color: "#374151" }}>
              오늘 예약 현황
            </p>
            <p className="text-xs mt-0.5" style={{ color: "#9CA3AF" }}>
              진행 중인 예약 3건 · 대기 중 1건
            </p>
          </div>
          <button
            onClick={() => navigate("/my-reservations")}
            className="text-xs font-semibold whitespace-nowrap cursor-pointer"
            style={{ color: "#2563EB" }}
          >
            보기
          </button>
        </div>
      </div>
    </div>
  );
}
